var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M5.33301 16.4999L9.33301 11.1666L14.6663 13.8333L21.333 5.83325L26.6663 11.1666M5.33301 25.8333L10.6663 17.8333L15.9997 20.4999L21.333 13.8333L26.6663 19.1666V25.8333H5.33301Z","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }